import { render } from "./HeroListShowDetailRuneRecItem.vue?vue&type=template&id=4879b148&scoped=true"
import script from "./HeroListShowDetailRuneRecItem.vue?vue&type=script&lang=js"
export * from "./HeroListShowDetailRuneRecItem.vue?vue&type=script&lang=js"

import "./HeroListShowDetailRuneRecItem.vue?vue&type=style&index=0&id=4879b148&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4879b148"]])

export default __exports__